import KmTabs from './main.vue'
KmTabs.install = function (vue) {
  vue.component(KmTabs.name, KmTabs)
}
export default KmTabs



// WEBPACK FOOTER //
// ./src/ui/components/tabs/index.js